import axionIns from "../axios";

const getBusinessInfo = async (
  page,
  perPage,
  search,
  planFilter,
  callToAction,
  isRegister,
  startDate,
  endDate,
  tangibleAsset,
  financialObjective,
  verificationMethod,
  isDefault,
  isActive = true
) => {
  const url = "admin/getinfocompanies";
  const params = {
    page,
    perPage,
    search,
    suggestedPlan: planFilter,
    callToAction,
    singaporRegistered:
      isRegister === "yes" ? true : isRegister === "no" ? false : "",
    startDate,
    endDate,
    tangibleAsset,
    financialObjective,
    verificationMethod,
    isDefault,
    // isActive
  };
  const response = await axionIns.get(url, { params });
  return response.data;
};

const editCompanyNotification = (companyId, id, value) => {
  return axionIns
    .put(
      `admin/${value === "cta"
        ? "updatenotificationbar"
        : value === "plan"
          ? "updatesubscriptionplan"
          : "updateCompanyDetails"
      }/${companyId}/${id}`
    )
    .then((response) => {
      return response.data;
    });
};

const editCompanyPosition = (id, payloadId) => {
  return axionIns
    .put(`admin/updateCompanyDetails/${id}`, JSON.stringify(payloadId))
    .then((response) => {
      return response.data;
    });
};
const updatebusinessInfo = (payload) => {
  return axionIns
    .put(`admin/updatebusinessinfo`, JSON.stringify(payload))
    .then((response) => {
      return response.data;
    });
};

const getAllCompanyAppointedList = () => {
  return axionIns.get("admin/company/list/appointed").then((response) => { return response.data });
};


const updateBobCta = (companyId, payload) => {
  return axionIns
    .put(`admin/company/updateBobCta/${companyId}`, JSON.stringify(payload))
    .then((response) => {
      return response.data;
    });
};

const approveCompany = (companyId, flag) => {
  let endpoint = `admin/company/${flag ? 'approve' : 'reject'}/${companyId}`
  return axionIns.post(endpoint).then((response) => {
    return response.data;
  });
};

const enableDisableAdvisor = (companyId, flag) => {
  let endpoint = `admin/${flag ? 'enableadvisor' : 'disableadvisor'}/${companyId}`
  return axionIns.put(endpoint).then((response) => {
    return response.data;
  });
};

const makeKimbocorpAdvisor = (companyId) => {
  let endpoint = `admin/enabledisablekimbovorpadvisor/${companyId}`
  return axionIns.put(endpoint).then((response) => {
    return response.data;
  });
};

const activateBusinessPayment = (payload) => {
  return axionIns.put("admin/company/business-activation/activate-payment", JSON.stringify(payload)).then((response) => {
    return response.data;
  });
};

const activateBusinessManual = (payload) => {
  return axionIns.post("admin/company/business-activation/manual", JSON.stringify(payload)).then((response) => {
    return response.data;
  });
};

let exportObj = {
  getBusinessInfo,
  editCompanyNotification,
  updatebusinessInfo,
  getAllCompanyAppointedList,
  editCompanyPosition,
  updateBobCta,
  approveCompany,
  enableDisableAdvisor,
  makeKimbocorpAdvisor,
  activateBusinessPayment,
  activateBusinessManual
};

export default exportObj;
